import Stepper, { StepperGeneralProps } from '.';

type StepBase = {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  icon?: React.ReactNode | ((color: string) => React.ReactNode);
  step: number;
};

type StepComponentProps = {
  circleProps?: Partial<StepperGeneralProps>;
  itemProps?: Partial<StepperGeneralProps>;
  indicatorProps?: Partial<StepperGeneralProps>;
  itemContentProps?: Partial<StepperGeneralProps>;
  spinnerProps?: Partial<StepperGeneralProps>;
  progressProps?: Partial<StepperGeneralProps>;
  wrapperProps?: Partial<StepperGeneralProps>;
};

export type Step = StepBase & Partial<StepComponentProps>;

interface StepperFabricProps extends StepperGeneralProps {
  steps: Step[];
}

export function StepperFabric({ steps, ...props }: StepperFabricProps) {
  return (
    <Stepper.render {...props}>
      {[...steps]
        .sort((a, b) => a.step - b.step)
        .map((step) => (
          <Stepper.Item {...{ ...props, ...step.itemProps }} key={step.step}>
            {/* In case of duplicated keys in the props object, the step.componentProps have the priority */}
            <Stepper.Indicator {...{ ...props, ...step.indicatorProps }}>
              <Stepper.Circle {...{ ...props, ...step.circleProps }}>
                {typeof step.icon === 'function' ? step.icon('#6c757d') : step.icon}
                <Stepper.CircleSpinner {...{ ...props, ...step.spinnerProps }} />
              </Stepper.Circle>
              {step.step !== Math.max(...steps.map((s) => s.step)) && (
                <Stepper.Progress {...{ ...props, ...step.progressProps }} />
              )}
            </Stepper.Indicator>
            <Stepper.ItemContent {...{ ...props, ...step.itemContentProps }}>
              <strong>{step.title}</strong>
              {step.description && <p>{step.description}</p>}
            </Stepper.ItemContent>
          </Stepper.Item>
        ))}
    </Stepper.render>
  );
}
